import React from 'react';
import { Box, Typography, Container } from '@mui/material';

import banner1 from '../../assets/banner1.webp';
import banner2 from '../../assets/banner2.webp';
import image2 from '../../assets/image2.webp';
import { useMediaQuery } from '@mui/material';

const contentCards = [
  {
    id: 1,
    titleBold: 'Humanizing Technology',
    description:
      'We constantly leverage innovative technology for ease of property shortlisting. Right from an interactive property viewing experience to serving real-time critical information on the go.',
    bgColor: '#c01524',
    image: banner1,
    alt: 'Tech Image',
  },
  {
    id: 2,
    titleBold: 'Insightful Data',
    description:
      'We create and deliver insights that anticipate the needs of the customer. With real-time tracking of 50+ parameters like supply & demand analysis, inventory movement, catchment analysis, etc., we cover the residential sector pan India for an ever-informed choice.',
    bgColor: '#111',
    image: banner2,
    alt: 'Data Image',
  },
];

const Advertisements = () => {
  const isTablet = useMediaQuery('(min-width:700px) and (max-width:1100px)');
  return (
    <Box sx={{ mt: 3, mb: 10, px: { xs: 1, md: 0 } }}>
      <Container maxWidth="xl" disableGutters>
        {/* Top RERA Card */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          background: 'white',
          borderRadius: '12px',
          width: { xs: '100%', md: '60%' },
          placeSelf: 'center',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          p: { xs: 0, sm: 4 },
          mb: 6,
          gap: { xs: 0, sm: 3 },
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'flex-start',
        }}>
          <Box sx={{ minWidth: { xs: 80, sm: 120 }, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: { xs: 2, sm: 0 } }}>
            <img loading='lazy' src={image2} alt="TS RERA" style={{ width: '120px', height: '120px', objectFit: 'contain', borderRadius: 20 }} />
          </Box>
          <Box sx={{ textAlign: { xs: 'center', sm: 'left' }, alignItems: { xs: 'center', sm: 'flex-start' }, width: '100%' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#222', mb: 1 }}>
              Real Estate Regulatory Authority (RERA)
            </Typography>
            <Typography sx={{ color: '#444', fontSize: 15 }}>
              Get a brief summary of RERA & its benefits here. You can also browse through RERA registered projects in Top cities.
            </Typography>
          </Box>
        </Box>

        {/* Bottom Cards Row */}
        <Box sx={{
          display: 'flex',
          flexDirection: isTablet ? 'column' : { xs: 'column', md: 'row' },
          gap: { xs: 4, md: 10 },
          justifyContent: 'center',
          alignItems: 'stretch',
        }}>
          {contentCards.map((card) => (
            <Box
              key={card.id}
              sx={{
                background: card.bgColor,
                color: 'white',
                borderRadius: '16px',
                p: { xs: 3, md: 3 },
                flex: 1,
                minWidth: 0,
                width: isTablet ? '100%' : { xs: '100%', md: '45%' },
                boxSizing: 'border-box',
                maxWidth: isTablet ? '100%' : { xs: '100%', md: '35%' },
                display: 'flex',
                gap: { xs: 2, md: 2 },
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'center',
                alignItems: { xs: 'center', sm: 'center' },
                position: 'relative',
                boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                minHeight: { xs: 180, md: 200 }
              }}
            >
              <Box sx={{
                minWidth: { xs: 80, sm: 90 },
                mb: { xs: 2, sm: 0 },
                mr: { xs: 0, sm: 2 },
                position: { xs: 'static', sm: 'absolute' },
                left: {sm: '30px', lg : '-55px' },
                top: { lg: '50%' },
                transform:{ lg: 'translateY(-50%)' },
                zIndex: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <img loading='lazy' src={card.image} alt={card.alt}
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    borderRadius: 20,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
                  }}
                />
              </Box>
              <Box sx={{
                width: { xs: '100%', sm: '50%' },
                placeSelf: 'center',
                textAlign: { xs: 'center', sm: 'left' }
              }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    color: 'white',
                    textAlign: { xs: 'center', sm: 'start' }
                  }}
                >
                  {card.titleBold}
                </Typography>
                <Typography
                  sx={{
                    alignContent: 'start',
                    fontSize: 14, color: 'white',
                    textAlign: { xs: 'center', sm: 'left' }
                  }}
                >
                  {card.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Advertisements;
